import type { ServiceInterface } from "types/service";

export function isProviderAvailable(
    service: Pick<ServiceInterface, "is_active" | "has_active_services">,
): boolean {
    if (typeof service.has_active_services === "boolean") {
        return service.has_active_services;
    }

    return service.is_active;
}
